import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import ModalRootPortal from "modules/root/modal-root-portal";
import ReactPlayer from "react-player";

const exitFullScreen = () => {
  if(document.exitFullscreen) {
    document.exitFullscreen();
  }
  else if(document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  }
  else if(document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}

class ModalVideo extends Component {
  static propTypes = {
    url: PropTypes.string,
    close: PropTypes.func
  };

  state = {
    show: false
  };

  show = () => this.setState({ show: true });
  hide = () => {
    this.setState({ show: false });
    setTimeout(this.props.close, 210);
  };

  componentDidMount() {
    setTimeout(this.show, 0);
  }

  render() {

    return (
      <ModalRootPortal>
        <div className={cx("VideoPlayer", { "is-visible": this.state.show })}>
          <ReactPlayer
            url={this.props.url}
            className="react-player"
            controls
            onEnded={exitFullScreen}
          />
          <div className="VideoPlayer-close" onClick={this.hide} />
        </div>
      </ModalRootPortal>
    );
  }
}

export default ModalVideo;



// WEBPACK FOOTER //
// ./src/modules/modal/modal-video.js